export { P50ProductDetailsPage as default } from './P50ProductDetailsPage';
export { PDPMetaFields } from './PDPMetaFields';
